<h1 mat-dialog-title>{{ 'labels.heading.View Client Signature' | translate }}</h1>

@if (signatureId) {
  <div mat-dialog-content>
    <img [src]="signatureImage" alt="Signature" />
  </div>
}

@if (!signatureId) {
  <div mat-dialog-content>
    <p>{{ 'labels.text.Client Signature is not provided.' | translate }}</p>
  </div>
}

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>{{ 'labels.buttons.Close' | translate }}</button>
  @if (signatureId) {
    <button mat-raised-button color="warn" [mat-dialog-close]="{ delete: true }">
      {{ 'labels.buttons.Delete' | translate }}
    </button>
  }
  @if (!signatureId) {
    <button mat-raised-button color="primary" [mat-dialog-close]="{ upload: true }">
      {{ 'labels.buttons.Upload' | translate }}
    </button>
  }
</mat-dialog-actions>
